// Letter bodies: circle-shaped Matter.Body tagged with char/stringId metadata.

import Matter from 'matter-js';

export type LetterPlugin = {
  char: string;
  stringId: string;
  charIndex: number;
  isLetter: true;
};

export function createLetterBody(
  char: string,
  x: number,
  y: number,
  radius: number,
  stringId: string,
  charIndex: number,
): Matter.Body {
  const body = Matter.Bodies.circle(x, y, radius, {
    restitution: 0.25,
    friction: 0.7,
    frictionStatic: 0.9,
    density: 0.002,
    slop: 0.02,
    label: `letter:${char}`,
    plugin: {
      char,
      stringId,
      charIndex,
      isLetter: true,
    } satisfies LetterPlugin,
  });
  // Small initial jitter so the letters separate as they fall.
  Matter.Body.setVelocity(body, {
    x: (Math.random() - 0.5) * 2.5,
    y: Math.random() * 1.5,
  });
  Matter.Body.setAngularVelocity(body, (Math.random() - 0.5) * 0.18);
  return body;
}

export function isLetterBody(body: Matter.Body): boolean {
  return (body.plugin as LetterPlugin | undefined)?.isLetter === true;
}

export function getLetterPlugin(body: Matter.Body): LetterPlugin | null {
  const p = body.plugin as LetterPlugin | undefined;
  return p?.isLetter ? p : null;
}
